import { TextField, FormHelperText, Button, Typography } from '@material-ui/core';
import { map } from 'rxjs/operators';
import React, { useCallback, useRef } from 'react';
import { useFormContext, useWatch, useController } from 'react-hook-form';
import { Observable, Subscription } from 'rxjs';
import { Autocomplete } from '@material-ui/lab';
import { debounce } from 'lodash';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import * as personService from '@api/person';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';
import { Grid, Chip, Link, Avatar, Select, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import PersonDefaultIcon from '@icon/person-default';
import { Link as Link1 } from 'react-router-dom';
import * as mapService from '@api/map';
import { catchError, tap } from 'rxjs/operators';
import { GenericLocationItem } from '@api/map/types';
import { createControlField } from '@lib/common';

const AutoCompleteEvent = ({ value, onChange, ...props}) => {
  const classesForAvatarImage = useStyles();
  const lastSubscription = useRef<Subscription>(null);
  const lastSearchedvalue = useRef<string>(null);

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [personCount, setPersonCount] = React.useState(null);
  const [filmingLocations, setFilmingLocations] = React.useState([])
  const [defaultLocation, setDefaultLocation] = React.useState(null)
  const [activeItem, setActiveItem] = React.useState<GenericLocationItem>(defaultLocation);
  // const [company, setCompany] = React.useState({});
  const onChangeHandle = useCallback(value => {
    // console.log({"valuein change": value});
    if (lastSearchedvalue.current && lastSearchedvalue.current == value && options.length > 0) {
      setOptions(prevOptions => [...prevOptions]);
      return;
    }
    setOptions([]);
    lastSearchedvalue.current = value;
    if (lastSubscription.current) {
      lastSubscription.current.unsubscribe();
    }
    setLoading(true);
    // let query = 'Mumbai'
    lastSubscription.current = mapService.filmingLocationIqSearch(value).pipe(
      tap(r => (r[0] ? setActiveItem(r[0]) : null)),
      catchError(err =>
        [400, 404].includes(err?.response?.status)
          ? Promise.reject(`No Results found for '${err?.config?.params?.q}'`)
          : Promise.reject(`${err}`)
      )
    )
      // .pipe(
      //   map(res => ({
      //     ...res,
      //     console.log(res)
      //     // data: res.data.data.map(d => {
      //     //   const reqdData = { ...d, id: d.vtr_id, person_vtr_id: d.vtr_id };
      //     //   delete reqdData.vtr_id;
      //     //   return reqdData;
      //     // }),
      //   }))
      // )
      .subscribe({
        next: data => {
          // console.log({"result map": data})
          setOptions(data);
          // setPersonCount(data.count);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  }, []);
  const debouncedOnChangeHandle = useCallback(
    debounce(value => onChangeHandle(value), 2000),
    [onChangeHandle]
  );

  // Ensure value is always an array for multiple autocomplete
  const safeValue = React.useMemo(() => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    return [value]; // Convert single value to array
  }, [value]);

  // Ensure options is always an array
  const safeOptions = React.useMemo(() => {
    return Array.isArray(options) ? options : [];
  }, [options]);

  return (
    <>
      <Autocomplete
        fullWidth
        // freeSolo={freeSolo}
        multiple
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        // disableClearable
        getOptionLabel={option => {
          // console.log({"Option": option.name +','+ option?.state +','+ option?.country})
          return (typeof option === 'object' ? (option.name +', '+ option?.state +', '+ option?.country) : option)
        }}
        disabled={props?.disabled}
        options={safeOptions}
        renderTags={(tagValue, getTagProps) => {
          // console.log({"tagValue":tagValue});
          // Safety check to ensure tagValue is an array
          if (!Array.isArray(tagValue)) {
            return [];
          }
          return tagValue.map((option, index) => (
            <Chip
              label={typeof option === 'object' ? `${option?.name}, ${option?.state}, ${option?.country}` : option}
              
              {...getTagProps({ index })}
              color="secondary"
            />
          ));
        }}
        renderOption={option => (
          <Grid container alignItems="center">
            <Grid item xs={12}>
            
              {option.name +', '+ option?.state +', '+ option?.country}
            </Grid>
            
          </Grid>
        )}
        loading={loading}
        loadingText={
          'Searching ... '
          // + (typeof value === 'object' ? value.name : value) + '...'
        }
        value={safeValue}
        onChange={(evt, v) =>onChange && onChange(v)}
        // onChange={(evt, v) => onChange && onChange(v)}
        renderInput={props => (
          <TextField
            id="filming-location-autocomplete"
            name="filmingLocation"
            // helperText="Select associated person relevant to this deal."
            label={'Filming Location'}
            placeholder={'Select Filming Location'}
            // error={!associatedPerson}
            // helperText={associatedPerson ? null : 'Associated member is mandatory'}
            fullWidth
            variant="outlined"
            {...props}
            onChange={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            onFocus={ev => {
              if (!!ev.target.value) {
                debouncedOnChangeHandle(ev.target.value);
              }
            }}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <>
                      <CircularProgress color="inherit" size={20} />
                      {props.InputProps.endAdornment}
                    </>
                  ) : value ? (
                    <>
                      {props.InputProps.endAdornment}
                      {/* <OfflinePinIcon style={{ fontSize: '1.5em' }} color="primary" /> */}
                    </>
                  ) : null}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <div
        className={
          personCount == 0
            ? open
              ? classesForAvatarImage.personStatus
              : classesForAvatarImage.personStatus1
            : ''
        }>
        <PersonStatus personData={personCount} />
      </div>
    </>
  );
}

export function PersonStatus(props) {
  const { personData } = props;
  if (personData == 0) {
    return (
      <FormHelperText>
        No Associated Person found <Link1 to="/person-management/new">Create New</Link1>
      </FormHelperText>
    );
  }
  return <FormHelperText>Select the Filming Location</FormHelperText>;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    personStatus: {
      marginTop: theme.spacing(8),
    },
    personStatus1: {
      marginTop: theme.spacing(1),
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    medium: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  })
);
export const FilmingLocationField = createControlField(AutoCompleteEvent, []);